import { useCallback, useEffect, useState } from 'react';

import { Spinner } from '@material-tailwind/react';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import numeral from 'numeral';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import { api, fetcher } from '@plugins/axios/api';

import { useRecoil } from '@hooks/useRecoil';

import { Button } from '@components/button/Button';
import { TOTAL_NAV_ITEM_LIST } from '@components/header/HeaderWrapper';
import { BasicPagination } from '@components/pagination/BasicPagination';
import { BasicTable } from '@components/table/BasicTable';
import { PageTitle } from '@components/title/PageTitle';

import { PageInfo, Paginated } from '@mocks/api';
import { ORDER_STATE } from '@mocks/projects';

export const PYesOrderListPage = () => {
  const [tmpPageInfo, setTmpPageInfo] = useState<PageInfo>({
    totalData: 0,
    currentPage: 1,
    limit: 10,
    startRow: 0,
    totalPages: 1,
  });
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, refetch, isFetching } = useQuery<Paginated<any>>({
    queryKey: [
      `/partner/orders?size=${tmpPageInfo['limit']}&order_state=200&order_state=202&order_state=300&only_partner=true`,
    ],
    queryFn: fetcher,
    staleTime: 10 * 1000,
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (!isFetching && data != undefined) {
      if ('pageInfo' in data) {
        setTmpPageInfo(data['pageInfo']);
      }
    }
  }, [isFetching, data]);

  return (
    <div className='container'>
      <PageTitle className='mt-4' titleHidden />
      <h1 className='text-3xl font-bold leading-[170%] tracking-tight'>
        접수 주문 목록
      </h1>
      <section className='mt-6'>
        <BasicTable
          captionPosition='top'
          isLoading={isFetching}
          caption={
            <div className='mb-2 flex w-full flex-row justify-start'>
              <BasicPagination
                className='mx-0 w-fit justify-start'
                currentPage={
                  searchParams.get('page')
                    ? Number(searchParams.get('page'))
                    : 1
                }
                totalPages={
                  data != undefined && 'pageInfo' in data
                    ? data['pageInfo']['totalPages']
                    : tmpPageInfo['totalPages']
                }
                limitPages={5}
              />
              {/* <Button
                variant='link'
                className='hover:text-[#2041ff] hover:no-underline'
                onClick={() => refetch()}
              >
                새로고침
                {isFetching && <Spinner className='mx-auto ml-2 h-4 w-4' />}
              </Button> */}
              <span className='ml-auto flex items-center text-base font-light leading-[100%]'>
                전체{' '}
                <strong className='pl-2 pr-1'>
                  {data != undefined && 'pageInfo' in data
                    ? data['pageInfo']['totalData']
                    : tmpPageInfo['totalData']}
                </strong>{' '}
                개
              </span>
            </div>
          }
          columns={[
            {
              header: 'no',
              accessorKey: 'idx',
              minSize: 30,
              maxSize: 30,
            },
            {
              header: '요청일',
              accessorKey: 'insert_at',
              minSize: 120,
              maxSize: 120,
              cell: (info) => {
                const date = info.getValue<string>();
                if (date != '-' && date != undefined) {
                  const dateTime = format(
                    new Date(date),
                    'yyyy-MM-dd&HH시 mm분',
                  ).split('&');
                  return (
                    <p>
                      {dateTime[0]}
                      <br />
                      {dateTime[1]}
                    </p>
                  );
                } else {
                  return <p>-</p>;
                }
              },
            },
            {
              header: '상태',
              accessorKey: 'order_state',
              minSize: 100,
              maxSize: 110,
              cell: (info) => {
                const state = info.getValue<number>();
                return (
                  <p className={ORDER_STATE[state]['lable-class']}>
                    {ORDER_STATE[state]['title']}
                  </p>
                );
              },
            },
            {
              header: '수량',
              accessorKey: 'order_items',
              minSize: 50,
              maxSize: 100,
              cell: (info) => {
                const list = info.getValue<string>();
                const arr: Array<any> = JSON.parse(list);
                return <p>{arr.length}</p>;
              },
            },
            {
              header: '상세',
              accessorKey: 'link_idx',
              minSize: 70,
              maxSize: 110,
              cell: (info) => {
                const orderIdx = info.getValue<string>();
                return (
                  <Button
                    className='px-3 py-2'
                    variant={'default'}
                    size='sm'
                    onClick={() => navigate('/partner/orders/' + orderIdx)}
                  >
                    보기
                  </Button>
                );
              },
            },
          ]}
          data={data != undefined ? data['list'] : []}
          className='flex h-fit w-full flex-col gap-12'
        />
        <BasicPagination
          className='mt-2 flex-1 justify-start'
          currentPage={
            searchParams.get('page') ? Number(searchParams.get('page')) : 1
          }
          totalPages={
            data != undefined && 'pageInfo' in data
              ? data['pageInfo']['totalPages']
              : tmpPageInfo['totalPages']
          }
          limitPages={5}
        />
      </section>
    </div>
  );
};
